import { useContext } from 'react'

import { CurrentShopContext } from '../providers/CurrentShopProvider'

export const useCurrentShopContext = () => {
  const currentShopContext = useContext(CurrentShopContext)

  if (currentShopContext === undefined) {
    throw new Error('currentShopContext must be used within a CurrentShopProvider')
  }

  return currentShopContext
}
